import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const HorizontalRule = ({ className, ...props }) => {
  const classes = classNames('HorizontalRule', className);

  return (
    <>
      <hr className={classes} {...props} />
      <style jsx>
        {`
          .HorizontalRule {
            display: block;
            margin: 0 0 ${Theme.get('spacing') * 3}px;
            padding: 0;
            background-color: ${Theme.get('colors-black')};
            height: 1px;
            border: none;
          }
        `}
      </style>
    </>
  );
};

HorizontalRule.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};

HorizontalRule.defaultProps = {
  children: null,
  className: '',
};

export default HorizontalRule;
